import React, { useState } from 'react';
import { jsx } from '@emotion/core';
 
export default function Spoiler(props) {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div>
      <button onClick={e => setCollapsed(!collapsed)}>
        {collapsed ?
        "Show"
        :
        "Hide"
        }
      </button>
      {collapsed ? null : props.children}
    </div>
  );
}